<template>
  <b-card>
    <!-- form -->
    <b-form class="mt-2">
      <b-row>
        <b-col md="6">
          <b-form-group
            label-for="namalengkap"
            label="Nama Lengkap"
          >
          <b-form-input
            disabled
            v-model="optionsLocal.name"
          />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            label-for="email"
            label="Email"
          >
          <b-form-input
            disabled
            v-model="optionsLocal.email"
          />
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
    <b-form class="mt-2">
      <b-row>
        <b-col md="6">
          <b-form-group
            label-for="nomorhp"
            label="Nomor HP"
          >
          <b-form-input
            disabled
            v-model="optionsLocal.nomor_hp"
          />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mt-2 mr-1"
            @click="apiWa"
          >
            WhatsApp
          </b-button>

        </b-col>
      </b-row>
    </b-form>
    <b-form class="mt-2" v-if="optionsLocalUPT.level === 'KANWIL' || optionsLocalUPT.level === 'UPT'">
      <b-row>
        <b-col md="6" v-if="optionsLocalUPT.level === 'UPT'">
          <b-form-group
            label-for="namaupt"
            label="Nama UPT"
          >
          <b-form-input
            disabled
            v-model="optionsLocalUPT.hak_akses"
          />
          </b-form-group>
        </b-col>

        <b-col md="6" v-if="optionsLocalUPT.level === 'KANWIL' || optionsLocalUPT.level === 'UPT'">
          <b-form-group
            label-for="nmkanwil"
            label="Nama Kanwil"
          >
          <b-form-input
            disabled
            v-model="optionsLocalUPT.hak_akses_kanwil"
          />
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BForm,
  BFormInput,
  BFormGroup,
  BRow,
  BCol,
  BAlert,
  BCard,
  BLink,
  BButton,
} from 'bootstrap-vue'
import {
  getTiket,
} from '@/connection-api/tiket'

export default {
  components: {
    BForm,
    BFormGroup,
    BRow,
    BCol,
    BCard,
    BFormInput,
    BButton,
  },
  data() {
    return {
      optionsLocal: {},
      optionsLocalUPT: {},
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  async mounted() {
    if (this.$route.params.id) {
      this.getTiket(this.$route.params.id)
    }
    // console.log(this.optionsLocal.select_proyek)
  },
  methods: {
    async getTiket(value) {
      const response = await getTiket(value)
      this.localData = response.data.data.created_by_user
      this.optionsLocal = this.localData

      this.localDataUPT = response.data.data.tiket_pengajuan
      this.optionsLocalUPT = this.localDataUPT

      if (this.optionsLocalUPT.hak_akses) {
        if (this.optionsLocalUPT.level === 'UPT') {
          const parts = this.optionsLocalUPT.hak_akses.split('\n')
          let uptUraian = ''
          let kanwilUraian = ''

          parts.forEach(part => {
            if (part.startsWith('UPT : ')) {
              uptUraian = part.replace('UPT : ', '')
            } else if (part.startsWith('KANWIL : ')) {
              kanwilUraian = part.replace('KANWIL : ', '')
            }
          })
          this.optionsLocalUPT.hak_akses = uptUraian
          this.optionsLocalUPT.hak_akses_kanwil = kanwilUraian
        } else if (this.optionsLocalUPT.level === 'KANWIL') {
          this.optionsLocalUPT.hak_akses_kanwil = this.optionsLocalUPT.hak_akses
        }
      }
    },
    apiWa() {
      // PERBAIKAN ZIKRI 26 JUNI 2024
      let phoneNumber = this.optionsLocal.nomor_hp
      if (phoneNumber.startsWith('08')) {
        phoneNumber = `+628${phoneNumber.slice(2)}`
      }
      // this.optionsLocal.nomor_hp
      // window.open('https://wa.me/15551234567', '_blank')
      window.open(`https://wa.me/${encodeURIComponent(phoneNumber)}`, '_blank')
    },
  },
}
</script>
